import * as React from 'react';
import './statusField.scss';
import '../metadataForm.scss';
import { Metadata, Schema, SchemaField } from '../../../types/Metadata';
import AccessControl from '../../AccessControl/accessControl';
import { DownArrow } from '../../Icon/icon';
import { useSelector } from '../../../utils/useSelector';
import { getItemStatus } from '../../../utils';
import { StatusCategory } from '../../../types/StatusCategory';
import { WorkflowPhase } from '../../../enums/WorkflowPhase';
import { ItemStatus } from '../../../enums/ItemStatus';

interface StatusFieldProps {
  schema: Schema;
  field: SchemaField;
  data: Partial<Metadata>;
  onChange: (newValue: Metadata, oldValue: Metadata) => any;
}

export const planningItemStatuses = [
  {
    id: '1',
    labels: ['Status'],
    props: {
      displayOrder: 1,
      description: 'Idea',
      id: 1,
      refId: 'status:1'
    }
  },
  {
    id: '10',
    labels: ['Status'],
    props: {
      displayOrder: 2,
      description: 'Concept Review',
      refId: 'status:10',
      id: 10
    }
  },
  {
    id: '11',
    labels: ['Status'],
    props: {
      displayOrder: 3,
      description: 'Not Pursued',
      refId: 'status:11',
      id: 11
    }
  }
] as Metadata[];

export const StatusField = ({
  field,
  schema,
  data,
  onChange
}: StatusFieldProps) => {
  const statusCategories = useSelector(s => s.planning?.statusCategories);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const dataRefId = data?.props?.refId;

  React.useEffect(() => {
    document.body.addEventListener('click', () => {
      setIsExpanded(false);
    });
  });

  const status = getItemStatus(data);
  if (!status) return null;

  const { id, description } = status.props;
  let buttonStyle = {};
  buttonStyle = getStatusColor(id, statusCategories[id]);

  return (
    <div className="status-field">
      <div className="dropdown">
        <AccessControl resource={{ ...field, dataSchema: schema }} data={data}>
          <button
            className={'dropdown-btn'}
            onClick={e => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            style={buttonStyle}
          >
            {description?.toLocaleUpperCase()}
            <DownArrow />
          </button>
        </AccessControl>
        {isExpanded && (
          <div className="dropdown-categories">
            {planningItemStatuses
              .filter(o => o?.props.id != id)
              .filter(
                o =>
                  (!dataRefId &&
                    [ItemStatus.Idea, ItemStatus.Concept_Review].includes(
                      o.props.id
                    )) ||
                  (dataRefId && id != ItemStatus.PendingRetirement) ||
                  (id == ItemStatus.PendingRetirement &&
                    o.props.id == ItemStatus.Concept_Review)
              )
              .sort((o1, o2) =>
                o1?.props?.displayOrder > o2?.props?.displayOrder ? 1 : -1
              )
              .map(o => {
                return (
                  <a
                    className="dropdown-item"
                    onClick={() => onChange(o, status)}
                  >
                    {o.props.description}
                  </a>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

const getStatusColor = (statusId: number, category: StatusCategory) => {
  const workflowPhaseId = category?.props?.id;
  let color = '#00A76D';
  if (workflowPhaseId == WorkflowPhase.authoring) {
    color = '#00A76D';
  } else if (workflowPhaseId == WorkflowPhase.raStudio) {
    color = '#2BCDBC';
  } else if (workflowPhaseId == WorkflowPhase.published) {
    color = '#007A50';
  }
  switch (statusId) {
    case 1:
      color = '#F66C9B';
      break;
    case 10:
      color = '#ED6926';
      break;
    case 11:
      color = '#A1B3CA';
      break;
    case 20:
      color = '#FB8C00';
      break;
    case 3000:
    case 3100:
    case 3200:
    case 3300:
    case 3400:
      color = '#007A50';
      break;
    case 6:
      color = '#DE0A01';
      break;
  }
  return { color };
};
